<template>
    <div class="federation-disabled-notice__base">
        <p v-if="showTitle" class="federation-disabled-notice__title">Single sign-on unavailable</p>
        <p class="federation-disabled-notice__body">
            Single sign-on is temporarily disabled for your organization.
            Please sign in with your email and password below, or use
            <a @click="$emit('forgot-password')">Forgot your password?</a>
            if you need to reset it.
        </p>
    </div>
</template>

<script>
export default {
    name: 'FederationNoticeContent',
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.federation-disabled-notice__base {
    width: 100%;
    padding: 12px;
    border-radius: 4px;
    background-color: #383e4c;
    font-size: 14px;
    line-height: 1.5;
    box-sizing: border-box;
    overflow-wrap: break-word;
    word-wrap: break-word;
}

.federation-disabled-notice__title {
    margin: 0 0 8px;
    font-weight: bold;
    color: #f3944c;
}

.federation-disabled-notice__body {
    margin: 0;
    color: #cbcbcb;
}

.federation-disabled-notice__body a {
    color: #f3944c;
    cursor: pointer;
    text-decoration: underline;
}

@media (max-width: 600px) {
    .federation-disabled-notice__base {
        font-size: 13px;
    }
}
</style>
